import { useEffect } from 'react';
import sqftConfig from '../../components/canvas/store/sqftConfig';
import useWindowDimensions from '../../hocs/useWindowDimensions';

const useUpdateSqftConfig = () => {
  const { windowWidth } = useWindowDimensions();

  useEffect(() => {
    sqftConfig.updateDefaultScale(windowWidth);
    sqftConfig.updateWorkspace(windowWidth);
  }, [windowWidth]);
};

export default useUpdateSqftConfig;
